import { addressTranslation } from "../address/address-translation";
import { config } from "../config";
import { currencyFormatterOrders } from "../currency";
import { getImprintInfo, getImprintProcessValueForHolographicTemp } from "../customization";
import { resizeImage, merchantisePantoneColor } from "../image";
const getOrderLocale = (country) => {
	if (country && addressTranslation && addressTranslation.country[country]) {
		const availableKeys = Object.keys(addressTranslation.country[country]);
		if (availableKeys.length !== 0) {
			return availableKeys[0] + '_' + country
		}
	} else {
		return config('locale').replace('-', '_');
	}
};

export const processCustomerOrder = (response , stateIdNameArray, statesKeyNameMap) => {
  let orderData = Array() as any;

  if(response.length == 0) 
    return orderData;
    
  for (let i = 0; i < response.length; i++) {
    let item = response[i];
    let itemAmount = 0;

    let option = {
    currency: item.currencyCode,
    country: item.country || 'IE',
    locale: getOrderLocale(item.country)
    };

    let artworkHold = item?.artworkHold || false;

    if (item.total) {
      itemAmount = currencyFormatterOrders(item.total, option);
    }

    let orderCreationDate = '';

    if (item.orderCreationDate) {
        orderCreationDate = item.orderCreationDate;
        if (config('locale') === 'en-US' || config('locale') === 'en-CA') {
            let result = item.orderCreationDate.split('-');
            if (result.length >= 3) {
              orderCreationDate = result[1] + '-' + result[0] + '-' + result[2];
            }
        }
    }

    let itemOrderState;
    let itemOrderStateKey;
    let itemPaymentState;
    let orderOrigin: any = item.orderOrigin;
    let orderedDate;

    let result = item.orderCreationDate.split('-');
    if (result.length >= 3) {
      orderedDate = result[1] + '-' + result[0] + '-' + result[2];
    }

    if (item.state && item.state.id) {
        itemOrderState = stateIdNameArray[item.state.id] ? stateIdNameArray[item.state.id].name : '...';
        itemOrderStateKey = stateIdNameArray[item.state.id] ? stateIdNameArray[item.state.id].key : '';
    }

    if (item.paymentStatus) {
        itemPaymentState = statesKeyNameMap[item.paymentStatus] || '...';
    }

    let namesArray = Array() as any;
    for (let l = 0; l < item.names?.length; l++) {
        if (!item.names[l] && item.nameAllLocales[l]) {
            for (let k = 0; k < item.nameAllLocales[l].length; k++) {
                if (item.nameAllLocales[l][k].locale === 'en') {
                  namesArray.push(item.nameAllLocales[l][k].value);
                }
            }
        }else{
          namesArray.push(item.names[l]);
        }
    }

    let itemImage: any = '';
    let lineItem = Array() as any;

    for (let i = 0; i < item.lineItems?.length; i++) {
      let productNameValue=item?.lineItems[i]?.name?.filter(nameVal=>nameVal.locale === config('locale'));
      if(!productNameValue || productNameValue?.length === 0 || productNameValue?.[0]?.value===''){
        productNameValue=item?.lineItems[i]?.name?.filter(nameVal=>nameVal.locale === 'en');
      }

      productNameValue = (!item.isATGOrder && productNameValue?.[0].value) || '';
      item = JSON.parse(JSON.stringify(item))
      if(item?.lineItems[i] && item?.lineItems[i]?.itemImage){
        itemImage = item.lineItems[i].itemImage;
      }
      else{
        itemImage = 'https://static.pens.com/public/img/noImageAvailable.jpg';
      }

      if(item.isATGOrder){
        item.lineItems = item.lineItems.filter(function (item) {
          return item.type === "personalizedItem";})
      }
      if(item.isATGOrder){
        productNameValue= item?.lineItems[i]?.skuName;
      }
      if (item.lineItems[i] && item.lineItems[i].productDetailsData) {
        let productDetailsData: any = {
          ...item.lineItems[i].productDetailsData,
          customizationInfo: getProductCustomizationDetails(item.lineItems[i])
        };
        item.lineItems[i].productDetailsData = productDetailsData;
      }

      item.lineItems[i]['lineitemStatusArray'] = [
        { 'workflow_state': 'Placed_Workflow', 'status': 'order_details.line_item_state_mapping.order_placed', 'completed': 'false' },
        { 'workflow_state': 'Personalization_Workflow', 'status': 'order_details.line_item_state_mapping.personalizing', 'completed': 'false' },
        { 'workflow_state': 'Shipped_Workflow', 'status': 'order_details.line_item_state_mapping.shipped', 'completed': 'false' },
        { 'workflow_state': 'Delivered_Workflow', 'status': 'order_details.line_item_state_mapping.delivered', 'completed': 'false' }
      ];

      if (item.lineItems[i] && item.lineItems[i].lineItemWorkflowStateKey) {
        let completedStateIndex = 0;
        for (let index = 0; index < item.lineItems[i].lineitemStatusArray.length; index++) {
          if (item.lineItems[i].lineItemWorkflowStateKey === 'Cancelled_Workflow') {
            item.lineItems[i].lineitemStatusArray = [{ 'workflow_state': 'Cancelled_Workflow', 'status': 'order_details.line_item_state_mapping.cancelled', 'completed': 'true' }];
          }
          else if (item.lineItems[i].lineItemWorkflowStateKey === item.lineItems[i].lineitemStatusArray[index].workflow_state) {
            completedStateIndex = index;
          }
        }
        while (completedStateIndex >= 0) {
          item.lineItems[i].lineitemStatusArray[completedStateIndex].completed = 'true';
          completedStateIndex--;
        }
      }

      let latestCompletedStatus = null;

      for (const order of item.lineItems[i].lineitemStatusArray) {
        if (order.completed === "true") {
          latestCompletedStatus = order.status;
        }
      }
      item.lineItems[i]['lineItemOrderStatus'] = latestCompletedStatus;

      item.lineItems[i]['free'] = {
        quantity: item.lineItems[i].freeQuantity
      }; 
      lineItem.push({ productName: productNameValue, ...item.lineItems?.[i], itemImage: itemImage, orderId: item.orderId, orderReference: item.orderReference, itemUnitPrice: item.lineItems?.[i].unitPrice, itemSubtotal: item.lineItems?.[i].totalPrice, itemSetupCharge:item.lineItems?.[i].setupCharge,   });
    }

    let orderObject = {
        createdAt: orderCreationDate || '',
        orderedDate: orderedDate || '',
        orderOrigin:orderOrigin || '',
        orderId: item.isATGOrder ? item.orderReference : item.orderId || '',
        orderNumber: item.orderReference || '',
        orderTotalAmount: itemAmount,
        paymentState: item.isATGOrder ? '' : itemPaymentState,
        orderState: itemOrderState || '...',
        orderStateKey: itemOrderStateKey || '',
        lineItem: lineItem || [],
        artworkHold: artworkHold || false,
        country: item?.country || '',
        isATGOrder:item?.isATGOrder || false
    };

    orderData.push(orderObject);
  }
  return orderData;
}

const getFormattedCurrency = (val, country, currencyCode, locale) => {
  const optionObj = {
    country,
    currency: currencyCode,
    locale: locale ? locale.replace('-', '_') : config('locale')
  };
  return currencyFormatterOrders(val, optionObj);
};

const priceModel = (obj, country, currencyCode, locale) => {
  let priceModelObj = { ...obj };
  priceModelObj.quantity = parseInt(obj.quantity);
  priceModelObj.unitPrice = getFormattedCurrency(obj.unitPrice, country, currencyCode, locale);
  priceModelObj.price = getFormattedCurrency(obj.price, country, currencyCode, locale);
  return priceModelObj;
};

const getFreeAndUpsellLineItems = (lineItems, country, currencyCode, locale) => {
  try {
    const lineItemsObj = JSON.parse(JSON.stringify(lineItems));
    lineItemsObj.forEach((mainItem) => {
      if (mainItem.upsell && Object.keys(mainItem.upsell).length !== 0) {
        mainItem.upsell = priceModel(mainItem.upsell, country, currencyCode, locale);
      }
      if (mainItem.free && Object.keys(mainItem.free).length !== 0) {
        mainItem.free = priceModel(mainItem.free, country, currencyCode, locale);
      }
      if (mainItem.accessory && mainItem.accessory.length !== 0) {
        mainItem.accessory = mainItem.accessory.map((accessoryItem) => priceModel(accessoryItem, country, currencyCode, locale));
      }
      if (mainItem.subitem && mainItem.subitem.length !== 0) {
        mainItem.subitem = mainItem.subitem.map((item) => priceModel(item, country, currencyCode, locale));
      }
      if (mainItem.additionalCharges) {
        mainItem.additionalCharges = mainItem.additionalCharges.map((charge) => {
          charge.totalValue = getFormattedCurrency(charge.totalValue, country, currencyCode, locale);
          charge.description = charge.description ? charge.description : 'false';
          return charge;
        });
      }
    });
    return lineItemsObj;
  } catch (ex) {
    console.log(ex);
  }
};


const getProcessedSpecification = (productSpecification, attributeList, imprintColorInfo) => {
  let info = Array() as any;
  const { imprintColor } = config('metaTextInfo');
  let imprintInfoAdded = false;
  if (productSpecification && productSpecification.specifications) {
    for (const attribute of productSpecification.specifications) {
      if (imprintColor === attribute.key && imprintColorInfo) {
        info.push(imprintColorInfo);
        imprintInfoAdded = true;
      } else if (attributeList.includes(attribute.key)) {
        if (Array.isArray(attribute.displayValue) && attribute.displayValue.length > 0) {
          info.push({
            attribute: attribute.displayName,
            value: attribute.displayValue.join(','),
            key: attribute.key
          });
        } else if (attribute.displayValue) {
          info.push({
            attribute: attribute.displayName,
            value: attribute.displayValue,
            key: attribute.key
          });
        }
      }
    }
  }
  if (!imprintInfoAdded && imprintColorInfo) {
    info.push(imprintColorInfo);
  }
  return info;
};

const getProductCustomizationDetails = (lineitemObj) => {
  let productAttrs = Array() as any;
  if (lineitemObj?.productDetailsData) {
    const imprintProcessValue = lineitemObj?.variableAttributes && getImprintProcessValueForHolographicTemp(lineitemObj?.variableAttributes);
    let attributesToIgnore = Array() as any, attributeList = Array() as any;
    if (lineitemObj.productDetailsData?.userSelectionInfo) {
      attributesToIgnore = lineitemObj.productDetailsData.userSelectionInfo.map(attribute => attribute.key);
    }
    const {
      maxLines,
      maxCharsPerLine,
      deliveryInfo
    } = config('metaTextInfo');
    attributesToIgnore = [...attributesToIgnore, maxLines, maxCharsPerLine, deliveryInfo];
    attributeList = lineitemObj.productDetailsData?.specifications
      .filter(attribute => attributesToIgnore.indexOf(attribute.key) === -1)
      .map(attribute => {
        if (imprintProcessValue && attribute.key === 'Imprint_Process') {
          attribute.displayValue = imprintProcessValue;
        }
        return attribute?.key;
      });
    const imprintColorInfo = getImprintInfo(lineitemObj?.customizationInfo, lineitemObj?.customizationType);
    productAttrs = getProcessedSpecification(lineitemObj?.productDetailsData, attributeList, imprintColorInfo) || [];
  }
  return productAttrs;
};

const processOrderLineitemData = (lineitems, isATGOrder, country, currencyCode, locale) => {
  try {
    let processedLineItem = Array() as any;
    let ATGLineItemStateMapping = {
      NO_PENDING_ACTION: 'shipped',
      CANCELLED: 'cancelled',
      REMOVED: 'cancelled'
    };
    if (lineitems && lineitems.length) {
      for (let i = 0; i < lineitems.length; i++) {
        let data = lineitems[i];
        data.lineitemStatusArray = [
          { 'workflow_state': 'Placed_Workflow', 'status': 'order_details.line_item_state_mapping.order_placed', 'completed': 'false' },
          { 'workflow_state': 'Personalization_Workflow', 'status': 'order_details.line_item_state_mapping.personalizing', 'completed': 'false' },
          { 'workflow_state': 'Shipped_Workflow', 'status': 'order_details.line_item_state_mapping.shipped', 'completed': 'false' },
          { 'workflow_state': 'Delivered_Workflow', 'status': 'order_details.line_item_state_mapping.delivered', 'completed': 'false' }
        ];
        data.lineItemId  = data.id;
        data.id = 'lineItem-index-' + i;
        data.itemImage = resizeImage(data.itemImage, "orderDetails");
        if (isATGOrder && data.itemStateName) {
          data.itemStateName = ATGLineItemStateMapping[data.itemStateName] ? ATGLineItemStateMapping[data.itemStateName] : '';
        }
        data.lineItemStateName = data.itemStateName !== '' ? (data.itemStateName.toLowerCase()).split(' ').join('_') : '';
        data.lineItemUnitPrice = getFormattedCurrency(data.itemUnitPrice, country, currencyCode, locale) || '';
        data.lineItemSubtotal = getFormattedCurrency(data.itemSubtotal, country, currencyCode, locale) || '';
        data.itemTotal = getFormattedCurrency(data.itemTotal, country, currencyCode, locale) || 0;
        data.isItemImportChargeFree = data?.itemImportCharge === '0.00' ? 'true' : 'false';
        data.itemImportCharge = getFormattedCurrency(data.itemImportCharge, country, currencyCode, locale) || 0;
        let itemLogoCharge = data.itemLogoCharge || '0.00';
        data.itemLogoCharge = itemLogoCharge;
        data.itemLogoCharge = getFormattedCurrency(itemLogoCharge, country, currencyCode, locale);
        data.hasSetupCharge = data.hasSetupCharge.toString();
        data.isLogoFree = data.isLogoFree.toString();
        data.isSetUpChargeFree = data.isSetUpChargeFree.toString();
        data.lineItemSetupCharge = getFormattedCurrency(data.itemSetupCharge, country, currencyCode, locale);
        data.lineItemDiscountCurrency = getFormattedCurrency(data.itemDiscount, country, currencyCode, locale);
        data.totalQuantity = Number(data.totalQuantity);
        data.quantity = Number(data.quantity);

        if (data.productDetailsData) {
          data.productDetailsData.customizationInfo = getProductCustomizationDetails(data);
        }
        if (data.lineItemWorkflowStateKey) {
          let completedStateIndex = 0;
          for (let index = 0; index < data.lineitemStatusArray.length; index++) {
            if (data.lineItemWorkflowStateKey === 'Cancelled_Workflow') {
              data.lineitemStatusArray = [{ 'workflow_state': 'Cancelled_Workflow', 'status': 'order_details.line_item_state_mapping.cancelled', 'completed': 'true' }];
            }
            else if (data.lineItemWorkflowStateKey === data.lineitemStatusArray[index].workflow_state) {
              completedStateIndex = index;
            }
          }
          while (completedStateIndex >= 0) {
            data.lineitemStatusArray[completedStateIndex].completed = 'true';
            completedStateIndex--;
          }
        }
        if (data.isMultiSelectable) {
          data.totalLineItemPrice = getFormattedCurrency(data.totalPriceWithSubItem, country, currencyCode, locale) || '';
        } else {
          data.totalLineItemPrice = getFormattedCurrency(data.itemSubtotal, country, currencyCode, locale) || '';
        }
        processedLineItem.push(data);
      }
    }
    return processedLineItem;
  } catch (ex) {
    console.log('Error in processOrderLineitemData()', ex);
  }
};

const isNAOrder = (country) => {
  return (country == 'US' || country == 'CA') ? 'true' : 'false';
}

const isUSOrder = (country) => {
  return (country == 'US') ? 'true' : 'false';
}

const isAuNzRegion = (country) => {
  return (country == 'AU' || country == 'NZ') ? 'true' : 'false';
}

export const processOrderDetails = (response, stateIdNameArray, statesKeyNameMap) => {
  const ATGPaymentStatusMapping = {
    invoicePayment: 'on_account',
    creditCard: 'credit_card',
    paypal: 'paypal'
  };
  if (response && response.orderId) {
    let orderDate = '';
    if (response.orderDate) {
      let result = response.orderDate.split('-');
      if (result.length >= 3) {
        orderDate = result[1] + '/' + result[0] + '/' + result[2];
        let orderDateArray = ((new Date(orderDate)).toString()).split(' ');
        orderDate = orderDateArray[1] + ' ' + orderDateArray[2] + ', ' + orderDateArray[3];
      }
    }

    let processedOrderData = {
      'orderId': response.orderId,
      'orderNumber': response.orderNumber ? response.orderNumber : '',
      'artworkHold': response?.artworkHold || false,
      'orderDate': orderDate ? orderDate.replace(/-/g, '&#8209;') : '',
      'shippingAddress': response.shippingAddress,
      'billingAddress': response.billingAddress,
      'lineItems': response.lineItems,
      'orderOrigin': response.orderOrigin,
      'VAT': getFormattedCurrency(response.VAT, response.country, response.currency, response.locale),
      'USBTax': parseInt(response.USBTax) !== 0 ? getFormattedCurrency(response.USBTax, response.country, response.currency, response.locale) : '0',
      'total': getFormattedCurrency(response.total, response.country, response.currency, response.locale),
      'paymentStatus': response.isATGOrder ? '' : statesKeyNameMap[response.paymentStatus],
      'orderStatus': response.state && response.state.id && stateIdNameArray[response.state.id] ? stateIdNameArray[response.state.id] : '...',
      'totalShippingCharges': response.totalShippingCharges ? getFormattedCurrency(response.totalShippingCharges, response.country, response.currency, response.locale) : '0',
      'totalDiscount': getFormattedCurrency(response.totalDiscount, response.country, response.currency, response.locale),
      'allItemsSubtotal': getFormattedCurrency(response.allItemsSubtotal, response.country, response.currency, response.locale),
      'paymentMethodInfo': response.paymentMethodInfo && response.paymentMethodInfo.type ? response.paymentMethodInfo.type : '',
      'country': response.country,
      'shippingType': response.shippingType ? response.shippingType.split(' ')[0] + ' ' + (response.shippingType.substring(response.shippingType.indexOf(' ') + 1)).toLowerCase() : '',
      'isATGOrder': response.isATGOrder,
      'isNAOrder': isNAOrder(response.country),
      'isAuNzRegion': isAuNzRegion(response.country),
      'isUSOrder': isUSOrder(response.country),
      'totalDiscountNumber': response.totalDiscount
    };
    if (response.isATGOrder) {
      processedOrderData.paymentMethodInfo = ATGPaymentStatusMapping[processedOrderData.paymentMethodInfo] ? ATGPaymentStatusMapping[processedOrderData.paymentMethodInfo] : '';
    }
    let updatedLineItems = getFreeAndUpsellLineItems(response.lineItems, response.country, response.currency, response.locale);
    processedOrderData.lineItems = processOrderLineitemData(updatedLineItems, response.isATGOrder, response.country, response.currency, response.locale);
    if (processedOrderData.shippingAddress && processedOrderData.shippingAddress.custom && processedOrderData.shippingAddress.custom.fields && processedOrderData.shippingAddress.custom.fields.phoneExtension) {
      processedOrderData.shippingAddress.extension = processedOrderData.shippingAddress.custom.fields.phoneExtension;
    }
    if (processedOrderData.billingAddress && processedOrderData.billingAddress.custom && processedOrderData.billingAddress.custom.fields && processedOrderData.billingAddress.custom.fields.phoneExtension) {
      processedOrderData.billingAddress.extension = processedOrderData.billingAddress.custom.fields.phoneExtension;
    }
    return processedOrderData;
  }
}

export const massageLineItem = (lineItem) => {
  lineItem['customizationInfo'] = lineItem.customizationInfo || '';
  lineItem['customizationType'] = lineItem.customizationType || '';
  lineItem['lineItemId'] = lineItem.id || '';
  lineItem['previewImageUrl'] = lineItem.customizationInfo.previewImageUrl || '';
  return lineItem;
}

export const getImprintTextDetails = (textInfo) => {
  const tempObj = {
      displayText: '',
      fontFamily: ''
  };
  const newTextDetails = {
      newTextDetailsArray: Array() as any,
      bgcolor: ''
  };

  if (textInfo && typeof textInfo === 'string') {
      const newTextInfo = textInfo.split('</FONT');
      for (let i = 0; i < newTextInfo.length; i++) {
          const splitByFont = newTextInfo[i].split('<FONT ');
          if (splitByFont.length > 1) {
              newTextDetails.newTextDetailsArray[i] = JSON.parse(JSON.stringify(tempObj));
              newTextDetails.newTextDetailsArray[i].displayText = '<FONT ' + splitByFont[1] + '</FONT>';
              const splitByFamily = newTextDetails.newTextDetailsArray[i].displayText.split('FACE=');
              const splitByColor = newTextDetails.newTextDetailsArray[i].displayText.split('COLOR=');
              if (splitByFamily.length > 1) {
                  const splitByQuote = splitByFamily[1].split('\"');
                  if (splitByQuote.length > 1) {
                      newTextDetails.newTextDetailsArray[i].fontFamily = splitByQuote[1].replace(/["' ]/g, '').toLowerCase();
                  }
                  if (splitByColor.length > 1) {
                      const splitColorByQuote = splitByColor[1].split('\"');
                      if (splitColorByQuote.length > 1 && (splitColorByQuote[1].toLowerCase() === '#ffffff' || splitColorByQuote[1].toLowerCase() === 'rgb(255,255,255)')) {
                          newTextDetails.bgcolor = '#cccccc';
                      }
                  }
              }
          }
      }
  }
  return newTextDetails;
}
